import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./collaboration-reason.actions";
import * as fromGraphql from "./collaboration-reason.graphql";


@Injectable()
export class CollaborationReasonEffects {
  create = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createCollaborationReasonMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_COLLABORATION_REASON,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(
                fromActions.upsertCollaborationReason({ collaborationReason: result?.data })
              );
              this.notificationService.successMessage('Created Successfully').then();
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code).then();
            }
          }
        })
      );
    })
  ), { dispatch: false });

  update = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateCollaborationReasonMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_COLLABORATION_REASON,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertCollaborationReason({ collaborationReason: result?.data })
              );
              this.notificationService.successMessage('Updated Successfully');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  get = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllCollaborationReasons),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_COLLABORATION_REASONS,
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching collaborationReasons'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadCollaborationReasons({ collaborationReasons: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  remove = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeCollaborationReason),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_COLLABORATION_REASON,
        variables: {
          uniqueId: action?.uniqueId
        },
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching collaborationReasons'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            if (result?.response?.status) {
              this.store.dispatch(fromActions.deleteCollaborationReason({ id: action?.id }))
              this.notificationService.successMessage(result?.response?.message).then();
            } else {
              this.notificationService.errorMessage(result?.response?.message).then();
            }
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
